import { UserLabel, UserStatus, UserTabEnum, UserTabParam } from "./types";

// ── RevenueCat product IDs by project ────────────────────────────────────────

// Production — project ec8a7485
const PROD_MONTHLY = ["prodfff97b37e2", "prodba1515d547", "prod85898252ad"]; // Play, App Store, Test
const PROD_ANNUAL = ["prodc743de8211", "prod44f731a85f", "prod132ab551ef"]; // Play, App Store, Test
const PROD_DISPLAY: Record<string, string> = {
  prodfff97b37e2: "Monthly", // Play Store
  prodba1515d547: "Monthly", // App Store
  prod85898252ad: "Monthly", // Test Store
  prodc743de8211: "Annual", // Play Store
  prod44f731a85f: "Annual", // App Store
  prod132ab551ef: "Annual", // Test Store
};

// Dev — project a792e451
// TODO: Add Play Store product IDs when Android dev app is set up.
const DEV_MONTHLY = ["prodfd2ec0bef2", "prodbd23bdd6ef"]; // App Store, Test Store
const DEV_ANNUAL = ["prod5cf869d680", "prod3ac11239e7"]; // App Store, Test Store
const DEV_DISPLAY: Record<string, string> = {
  prodfd2ec0bef2: "Monthly", // App Store (dev)
  prodbd23bdd6ef: "Monthly", // Test Store (dev)
  prod5cf869d680: "Annual", // App Store (dev)
  prod3ac11239e7: "Annual", // Test Store (dev)
};

// ── Merged exports ───────────────────────────────────────────────────────────
export const PRODUCT_DISPLAY_NAMES: Record<string, string> = { ...PROD_DISPLAY, ...DEV_DISPLAY };
export const MONTHLY_PRODUCT_IDS = [...PROD_MONTHLY, ...DEV_MONTHLY];
export const ANNUAL_PRODUCT_IDS = [...PROD_ANNUAL, ...DEV_ANNUAL];

export const STORE_DISPLAY_NAMES: Record<string, string> = {
  play_store: "Play Store",
  app_store: "App Store",
  test_store: "Test Store",
};

// --- Users page constants ---

// Map key names to the expected API key names for sorting.
// This mapping ensures that the keys sent to the API match the expected parameter names.
// Keys not included in this map will be sent as is without any transformation.
export const mapSortById: Record<string, string> = {
  onboardingStatus: "onboardingCompleted",
};

export const defaultSortParams: { sortBy: string; sortOrder: "DESC" | "ASC" } = {
  sortBy: "createdAt",
  sortOrder: "DESC",
};

// Column visibility presets
// To add a new column: just add its accessorKey to the right group below.
// Columns NOT listed here are always visible (id, name, email, action).
export const COLUMN_GROUPS: Record<string, ColumnView[]> = {
  // Basic — shown in "activity" view, hidden in "subscription" view
  roles: ["activity"],
  status: ["activity"],
  createdAt: ["activity"],
  // Activity — shown in "activity" view
  onboardingStatus: ["activity"],
  lastLoginAt: ["activity"],
  mostRecentLoginCity: ["activity"],
  mostRecentLoginCountry: ["activity"],
  mostRecentLoginDevice: ["activity"],
  totalCulturesSubscribed: ["activity"],
  totalTagsSubscribed: ["activity"],
  totalLikes: ["activity"],
  totalHides: ["activity"],
  totalShares: ["activity"],
  updatedAt: ["activity"],
  // Subscription — shown in "subscription" view
  subscribedAt: ["subscription"],
  subscriptionStatus: ["subscription"],
  subscriptionProductId: ["subscription"],
  subscriptionStore: ["subscription"],
  subscriptionStartAt: ["subscription"],
  subscriptionEndAt: ["subscription"],
  unsubscribedAt: ["subscription"],
  customTrialStatus: ["subscription"],
};

export type ColumnView = "all" | "subscription" | "activity";

export const getColumnVisibility = (view: ColumnView): Record<string, boolean> =>
  Object.fromEntries(Object.entries(COLUMN_GROUPS).map(([col, groups]) => [col, view === "all" || groups.includes(view)]));

export enum ConfirmDialogEnum {
  Activate = "Activate",
  InActivate = "InActivate",
}

export type ConfirmDialogType = keyof typeof ConfirmDialogEnum;

export const userTabParams: UserTabParam[] = [
  {
    label: UserLabel.MobileUsers,
    value: UserTabEnum.MobileUsers,
    params: {
      status: UserStatus.Active,
      roles: ["Mobile User"],
    },
  },
  {
    label: UserLabel.WebOnly,
    value: UserTabEnum.WebOnly,
    params: {
      status: UserStatus.Active,
      roles: ["Admin", "Creator", "Approver", "Translator", "Marketing"],
    },
  },
  {
    label: UserLabel.AllActive,
    value: UserTabEnum.AllActive,
    params: {
      status: UserStatus.Active,
    },
  },
  {
    label: UserLabel.Inactive,
    value: UserTabEnum.InActive,
    params: {
      status: UserStatus.Inactive,
    },
  },
];
